import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from '@angular/common';
import { ErrorService } from "@services/error.service";
import { SessionService } from "@services/session.service";
import { DangerError, WarningError } from "@shared/errors/custom.error";
import { ExpedienteService } from "@services/expediente.service";
import { BaseFuncionalidadComponent } from "@shared/base/base-funcionalidad.component";
import IMotivo from "@models/motivo.interface";
import { Archivo } from "@models/archivo.model";
import { TerminologiaService } from "@services/terminologia.service";
import ExpedienteEstados from "@shared/enums/expediente-estados.enum";
import { StateService } from "@services/state.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import sprintf from "@shared/utils/sprintf.util";
import { Mensajes } from "@shared/enums/mensajes.enum";
import AccionesFuncionalidad from "@shared/enums/acciones.enum";

@Component({
    selector: "app-expedientes-detalle-prorroga",
    templateUrl: "./expedientes-detalle-prorroga.component.html",
    styleUrls: ["./expedientes-detalle-prorroga.component.scss"],
})
export class ExpedientesDetalleProrrogaComponent extends BaseFuncionalidadComponent {
    constructor(
        sessionService: SessionService,
        route: ActivatedRoute,
        router: Router,
        location: Location,
        stateService: StateService,
        private errorService: ErrorService,
        private expedienteService: ExpedienteService,
        private terminologiaService: TerminologiaService,
        private sanitizer: DomSanitizer
    ) {
        super(route, sessionService, location, router, stateService);
    }

    isLoading: boolean = false; // Variable que maneja el renderizado del spinner de carga inicial
    isLoadingDocumento: boolean = false; // Variable que maneja el renderizado del spinner de carga del documento

    documentoSeleccionado: Archivo; // Variable que guarda el documento seleccionado
    motivoSeleccionado: IMotivo; // Variable que guarda el motivo seleccionado

    mostrarModal: boolean = false; // Variable que maneja el renderizado del modal

    motivos: IMotivo[];
    
    isPDF: boolean; // Variable que maneja si el documento es un pdf
    mensajeExito: string; // variable que guarda el mensaje de exito en la acción del expediente
    urlTemporal: SafeResourceUrl; // Variable que guarda la url temporal del documento cargado

    ngOnInit() {
        this.prorrogaSolicitada = [ExpedienteEstados.solicitud_prorroga, ExpedienteEstados.prorroga_aprobada, ExpedienteEstados.prorroga_rechazada].includes(this.expediente.estado.codigo)

        this.obtenerMotivos();
        this.obtenerDocumentoProrroga();
    }
  
    get mensajeSinPermisos(): string {
        return this.terminologiaService.obtenerMensajePorID(Mensajes.sin_permisos_funcionalidad);
    }

    get mensajeSinPermisosAccion(): string {
        return this.terminologiaService.obtenerMensajePorID(Mensajes.sin_permisos_accion);
    }

    get mensajeSolicitarProrroga(): string {
        const mensaje = this.terminologiaService.obtenerMensajePorID(Mensajes.solicitar_prorroga);
        return sprintf(mensaje, this.expediente.id);
    }

    get tituloProrroga(): string {
        const accion = this.prorrogaSolicitada ? AccionesFuncionalidad.solicitar_prorroga : AccionesFuncionalidad.ver_prorroga
        return this.sessionService.getAction(this.idFuncionalidad, accion).nombre_acc
    }

    async obtenerMotivos() {
        try {
            if (!this.canRequestExtend && !this.canReadExtend) throw new DangerError(this.mensajeSinPermisosAccion);
            this.motivos = this.terminologiaService.obtenerMotivosSolicitudProrroga();
        } catch (error) {
            this.errorService.handle(error, "Error al obtener los motivos.");
        } finally {
            this.isLoading = false;
        }
    }

    async obtenerDocumentoProrroga() {
      if (!this.prorrogaSolicitada) return;
      this.isLoadingDocumento = true;
      try {
        const archivo = await this.expedienteService.obtenerDocumentoProrroga(this.id);
        this.expediente.motivo.archivo = archivo;
        this.isPDF = archivo.extension === 'pdf';
        this.urlTemporal = this.sanitizer.bypassSecurityTrustResourceUrl(archivo.url_documento);
      } catch (error) {
          this.errorService.handle(error, "Error al obtener la información del documento.");
      } finally {
          this.isLoadingDocumento = false;
      }
    }

    asignarDocumento(file: Archivo) {
        this.documentoSeleccionado = file;
    }

    abrirModal() {
        this.mostrarModal = true;
    }

    async enviarSolicitud() {
        this.isLoadingModal = true;
        try {
            if (!this.canSendDoc) throw new DangerError(this.mensajeSinPermisosAccion);

            if (!this.motivoSeleccionado) throw new WarningError("Debe seleccionar un motivo.");
            if (!this.documentoSeleccionado) throw new WarningError("Debe seleccionar un documento.");

            this.mensajeExito = await this.expedienteService.solicitarProrrogaExpediente(this.id, this.documentoSeleccionado, this.motivoSeleccionado.nombre);
            this.mostrarModal = false;
            this.mostrarModalConfirmacion = true; // Encadena el modal de confirmación tras aceptar
        } catch (error) {
            this.errorService.handle(error, "Se produjo un error al enviar la solicitud de prórroga.");
        } finally {
            this.isLoadingModal = false;
        }
    }

    /* Vuelve al listado de expedientes al cerrar el modal de confirmación */
    onModalConfirmacionCerrado() {
        this.mostrarModalConfirmacion = false;
        this.volverDosPaginasAtras();
    }
}
